export default __webpack_public_path__ + "locales/ko-KR/PreparationPortal.json?hash=724e9d1674ed9a8feadff4e227c0873d";